export default __webpack_public_path__ + "static/media/TextBoxSearchIcon.a023d33f.svg";